import { OptionsObject, SnackbarMessage, enqueueSnackbar } from "notistack";

export const renderNotifier = (
  message: SnackbarMessage,
  options?: OptionsObject
) => {
  return enqueueSnackbar(message, options);
};
